function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.3 21.73c-.164-.082-.134-.228-.004-.275l.407-.148-1.93-5.305-3.847 1.4a1.406 1.406 0 00-.84 1.802l.968 2.661a1.407 1.407 0 001.791.845c.562.233 2.01.977 3.363 2.85.164.228.46.318.723.221l1.79-.651a.63.63 0 00.299-.953c-1.07-1.528-2.21-2.19-2.72-2.447z",
  fill: "#FFF9E2",
  stroke: "#FB984A",
  strokeWidth: 4,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.13 10.146l-.578.21s-1.83 4.277-4.202 5.418l.006.015.145.398L9.288 21.1c2.55-.652 6.7 1.448 6.7 1.448l.578-.21a.894.894 0 00.534-1.145L13.274 10.68a.892.892 0 00-1.145-.534z",
  fill: "#FFF9E2",
  stroke: "#FB984A",
  strokeWidth: 4,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.538 13.19c-.244-.668-1.023-.65-2.691.255-.464.251-.76.56-.62.95.142.389.606.49 1.139.382 1.964-.395 2.415-.919 2.172-1.587zM16.29 7.872c-.679-.212-1.136.419-1.43 2.294-.081.521-.015.945.38 1.068.396.123.758-.183.995-.672.877-1.802.734-2.478.055-2.69zM19.894 9.419c-.568-.428-1.211.012-2.117 1.68-.252.464-.332.885-.002 1.134.33.248.775.081 1.163-.299 1.432-1.403 1.524-2.087.956-2.515zM21.192 21.38c-.384.598-1.14.41-2.57-.839-.397-.347-.619-.713-.396-1.062.224-.349.699-.346 1.195-.125 1.83.817 2.156 1.427 1.771 2.025zM22.956 17.87c-.16.694-.936.77-2.703.075-.49-.194-.823-.465-.73-.867.093-.404.542-.561 1.083-.52 1.998.155 2.51.619 2.35 1.312z",
  fill: "#FFF9E2",
  stroke: "#FB984A",
  strokeWidth: 4,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.947 10.536c-.637.09-1.002.392-1.25.74-.333-.268-.767-.457-1.405-.367-1.024.144-1.69.993-1.553 1.977.187 1.33 2.16 2.86 3.382 3.288a.57.57 0 00.518-.073c1.058-.749 2.532-2.762 2.345-4.092-.138-.984-1.013-1.617-2.037-1.473zM27.594 19.02c-.643-.045-1.063.175-1.377.464-.27-.33-.656-.606-1.298-.65-1.03-.072-1.86.62-1.93 1.61-.094 1.34 1.518 3.247 2.625 3.919a.577.577 0 00.522.036c1.19-.512 3.05-2.175 3.144-3.515.07-.99-.655-1.791-1.686-1.863zM23.35 4.626c-.642.046-1.027.32-1.298.651-.314-.29-.734-.509-1.377-.464-1.03.072-1.755.874-1.686 1.864.094 1.34 1.955 3.004 3.144 3.516a.579.579 0 00.522-.037c1.107-.672 2.718-2.578 2.625-3.918-.069-.991-.9-1.684-1.93-1.612z",
  fill: "#FFE000",
  stroke: "#FB984A",
  strokeWidth: 4,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.3 21.73c-.164-.082-.134-.228-.004-.275l.407-.148-1.93-5.305-3.847 1.4a1.406 1.406 0 00-.84 1.802l.968 2.661a1.407 1.407 0 001.791.845c.562.233 2.01.977 3.363 2.85.164.228.46.318.723.221l1.79-.651a.63.63 0 00.299-.953c-1.07-1.528-2.21-2.19-2.72-2.447z",
  fill: "#FFF9E2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.13 10.146l-.578.21s-1.83 4.277-4.202 5.418l.006.015.145.398L9.288 21.1c2.55-.652 6.7 1.448 6.7 1.448l.578-.21a.894.894 0 00.534-1.145L13.274 10.68a.892.892 0 00-1.145-.534z",
  fill: "#FFF9E2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.538 13.19c-.244-.668-1.023-.65-2.691.255-.464.251-.76.56-.62.95.142.389.606.49 1.139.382 1.964-.395 2.415-.919 2.172-1.587zM16.29 7.872c-.679-.212-1.136.419-1.43 2.294-.081.521-.015.945.38 1.068.396.123.758-.183.995-.672.877-1.802.734-2.478.055-2.69zM19.894 9.419c-.568-.428-1.211.012-2.117 1.68-.252.464-.332.885-.002 1.134.33.248.775.081 1.163-.299 1.432-1.403 1.524-2.087.956-2.515zM21.192 21.38c-.384.598-1.14.41-2.57-.839-.397-.347-.619-.713-.396-1.062.224-.349.699-.346 1.195-.125 1.83.817 2.156 1.427 1.771 2.025zM22.956 17.87c-.16.694-.936.77-2.703.075-.49-.194-.823-.465-.73-.867.093-.404.542-.561 1.083-.52 1.998.155 2.51.619 2.35 1.312z",
  fill: "#FFF9E2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M27.947 10.536c-.637.09-1.002.392-1.25.74-.333-.268-.767-.457-1.405-.367-1.024.144-1.69.993-1.553 1.977.187 1.33 2.16 2.86 3.382 3.288a.57.57 0 00.518-.073c1.058-.749 2.532-2.762 2.345-4.092-.138-.984-1.013-1.617-2.037-1.473zM27.594 19.02c-.643-.045-1.063.175-1.377.464-.27-.33-.656-.606-1.298-.65-1.03-.072-1.86.62-1.93 1.61-.094 1.34 1.518 3.247 2.625 3.919a.577.577 0 00.522.036c1.19-.512 3.05-2.175 3.144-3.515.07-.99-.655-1.791-1.686-1.863zM23.35 4.626c-.642.046-1.027.32-1.298.651-.314-.29-.734-.509-1.377-.464-1.03.072-1.755.874-1.686 1.864.094 1.34 1.955 3.004 3.144 3.516a.579.579 0 00.522-.037c1.107-.672 2.718-2.578 2.625-3.918-.069-.991-.9-1.684-1.93-1.612z",
  fill: "#FFE000"
});

var SvgIcEveryone = function SvgIcEveryone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcEveryone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_everyone.6ada200a.svg";
export { ForwardRef as ReactComponent };